import { useSelector } from "react-redux";
import { ResponseTab } from "../../RFIS/ResponstTab";

export const Vendors = () => {
  const { client_id, client_secret } = useSelector(
    (state) => state.clientSecrets
  );

  // Use a relative route inside the embedded Hypercomply app so ResponseTab
  // can post a navigation message (same flow as Segmentation)
  const route = "/due-diligence/vendors?hideNavigation=true";

  return (
    <div className="w-full ">
      {client_id && client_secret && (
        <ResponseTab
          clientSecrets={{ client_id, client_secret }}
          route={route}
          heading={"View Vendors"}
          desc={"vendors"}
        />
      )}
    </div>
  );
};
